import { ele } from "cables-shared-client";
import web from "../../index.js";
import PatchLists from "../../patchlists.js";

export default class PagePatchlist
{
    constructor(targetElement)
    {
        this.listId = targetElement.dataset.listid;
        this.patchLists = new PatchLists();
        this.patchLists.displayPatchList(ele.byId("patchlist"), false, this.listId, () =>
        {
            web.favs.showFavToggle(ele.byId("toggleFav"));
        });
    }
}
